import React, {useState} from 'react';
import {at} from 'lodash';
import {useField} from 'formik';
import {TextField} from '@material-ui/core';

export function useFastField(props)  {
    const setAffinityName = props.setAffinityName;
    const [field, meta, setFieldValue] = useField(props);
    const [value, setValue] = useState(field.value);
    const { onBlur, onChange } = field;
    let method;

    switch (props.textTransform) {
        case 'capitalize':
            method = (val) => {return val.charAt(0).toUpperCase() + val.slice(1);}
            break;
        case 'uppercase':
            method = (val) => {return val.toUpperCase()}
            break;
        case 'lowercase':
            method = (val) => {return val.toLowerCase()}
            break;
        default:
            method = (val) => val
            break;
    }

    field.value = value;
    field.onChange = (e) => {
        if(e.currentTarget.name === "company_name"){
            setAffinityName(e.currentTarget.value);
        }
        if (e && e.currentTarget) {
            setValue(method(e.currentTarget.value));
            setFieldValue.setTouched(e.currentTarget)
            setFieldValue.setValue(e.currentTarget.value)
        }
    };
    field.onBlur = (e) => {
        onBlur(e);
        onChange(e);
    };

    return [field, meta];
}

export default function InputField(props) {
    const {errorText, ...rest} = props;
    const [field, meta] = useFastField(props);


    function _renderHelperText() {
        const [touched, error] = at(meta, 'touched', 'error');
        if (touched && error) {
            return error;
        }
    }

    return (
        <TextField
            error={meta.touched && meta.error}
            helperText={_renderHelperText()}
            {...field}
            {...rest}
        />
    );
}
